import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { db } from "../common/firebase.utils"
import MarqueeSlider from "../common/MarqueeSlider"
import ProfilePicture from "../common/ProfilePicture"

export default function MembershipUsers() {
  const [membershipUsers, setMembershipUsers] = useState()

  useEffect(() => {
    db.collection("users")
      .where("isMembership", "==", true)
      .get()
      .then(snapshot => {
        const users = []
        const shuffled = snapshot.docs.sort(() => Math.random() - 0.5)
        shuffled.forEach(doc => {
          const { nickname, photo } = doc.data()
          users.push({ nickname, photo })
        })
        setMembershipUsers(users)
      })
  }, [])

  if (!membershipUsers) return null

  return (
    <Section>
      <SectionLabel>Loved by People</SectionLabel>
      <Title>
        <DesktopOnly>
          무료로 시작하고, 만족해서 <strong>멤버십</strong>까지 이용하고 있어요
        </DesktopOnly>
        <MobileOnly>
          무료로 시작하고, 만족해서 <strong>멤버십</strong>까지
        </MobileOnly>
      </Title>
      <MarqueeWrapper>
        <MarqueeSlider speed={40} gap={16}>
          {membershipUsers.map((user, index) => (
            <UserCard key={index}>
              <ProfilePicture src={user.photo} size="2.5rem" />
              <UserName>{user.nickname}</UserName>
              <UserSuffix>님</UserSuffix>
            </UserCard>
          ))}
        </MarqueeSlider>
      </MarqueeWrapper>
    </Section>
  )
}

const Section = styled.div`
  padding: 96px 0;
  text-align: center;
  background: #fafafa;

  @media (max-width: 800px) {
    padding: 64px 0;
  }
`

const SectionLabel = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #5551ff;
  margin-bottom: 0;
  letter-spacing: -0.01em;
`

const Title = styled.h2`
  font-size: 28px;
  font-weight: 400;
  color: #0f0e2c;
  line-height: 140%;
  margin-bottom: 48px;

  strong {
    font-weight: 700;
  }

  @media (max-width: 800px) {
    font-size: 18px;
    margin-bottom: 32px;
    padding: 0 24px;
  }
`

const DesktopOnly = styled.span`
  @media (max-width: 480px) {
    display: none;
  }
`

const MobileOnly = styled.span`
  display: none;
  @media (max-width: 480px) {
    display: inline;
  }
`

const MarqueeWrapper = styled.div`
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 200px;
    z-index: 1;
    pointer-events: none;
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, #fafafa 0%, transparent 100%);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, #fafafa 0%, transparent 100%);
  }

  @media (max-width: 800px) {
    &::before,
    &::after {
      width: 100px;
    }
  }
`

const UserCard = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  background: #ffffff;
  padding: 14px 20px;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #e0dfff;
    box-shadow: 0 2px 12px rgba(85, 81, 255, 0.06);
  }
`

const UserName = styled.span`
  font-weight: 500;
  font-size: 15px;
  color: #0f0e2c;
  margin-left: 10px;
  white-space: nowrap;
`

const UserSuffix = styled.span`
  font-size: 15px;
  color: #9ca3af;
`
